<form (ngSubmit)="onSubmit()" [formGroup]="group">
  <div class="wrapper-title">
    <ui-form-markup [data]="dataTitle"></ui-form-markup>
    <button class="close-button" type="button" (click)="closeClicked.emit()">
      <ui-icon faName="xmark" faStyle="light"></ui-icon>
    </button>
  </div>
  @if (error) {
    <ui-alert [message]="error!" theme="error"></ui-alert>
  }
  <div [hidden]="error" class="wrapper-controls">
    <ui-form-markup [data]="dataProductDetail"></ui-form-markup>
    <ui-form-quantity-counter
      class="text-bold"
      [data]="dataQuantityCounter"
      [formControlName]="dataQuantityCounter.name"
    ></ui-form-quantity-counter>
    <ui-form-markup [data]="dataShoppingListInfo"></ui-form-markup>
    <ui-form-select
      [data]="dataShoppingList"
      [formControlName]="dataShoppingList.name"
    ></ui-form-select>
    <ui-form-text
      [data]="dataShoppingListName"
      [formControlName]="dataShoppingListName.name"
    ></ui-form-text>
  </div>
  <div class="wrapper-actions">
    <ui-button buttonStyle="text" type="button" (click)="abortClicked.emit()">Abbrechen</ui-button>
    @if (!error) {
      <ui-button type="submit">Speichern</ui-button>
    } @else {
      <ui-button type="button" (click)="retryClicked.emit()">Erneut versuchen</ui-button>
    }
  </div>
</form>
